import { Fragment, useState } from "react";
import { formatDuration } from "../utils/format";

function rowClass(status) {
  if (status === "success") return "bg-emerald-50/60";
  if (status === "partial") return "bg-amber-50/60";
  if (status === "failed") return "bg-red-50/60";
  return "";
}

export function SyncLogTable({ logs = [], loading, onRowClick }) {
  const [expandedId, setExpandedId] = useState(null);

  if (loading) {
    return (
      <div className="rounded-lg border bg-white p-6 text-sm text-slate-500">
        Loading logs…
      </div>
    );
  }

  if (!logs.length) {
    return (
      <div className="rounded-lg border bg-white p-6 text-sm text-slate-500">
        No sync logs yet.
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
      <table className="min-w-full text-left text-sm">
        <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
          <tr>
            <th className="px-4 py-3">Type</th>
            <th className="px-4 py-3">Started</th>
            <th className="px-4 py-3">Duration</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3">Pulled</th>
            <th className="px-4 py-3">Created</th>
            <th className="px-4 py-3">Updated</th>
            <th className="px-4 py-3">Error</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log) => (
            <Fragment key={log._id}>
              <tr
                className={`cursor-pointer border-t ${rowClass(log.status)}`}
                onClick={() => {
                  setExpandedId(expandedId === log._id ? null : log._id);
                  onRowClick?.(log);
                }}
              >
                <td className="px-4 py-3 font-medium">{log.syncType}</td>
                <td className="px-4 py-3">
                  {log.startedAt
                    ? new Date(log.startedAt).toLocaleString()
                    : "—"}
                </td>
                <td className="px-4 py-3">
                  {formatDuration(log.startedAt, log.completedAt)}
                </td>
                <td className="px-4 py-3 capitalize">{log.status}</td>
                <td className="px-4 py-3">
                  {(log.recordsPulled ?? 0) === 0 &&
                  log.syncType === "delta" &&
                  log.status === "success" ? (
                    <span className="text-slate-500">No changes</span>
                  ) : (
                    (log.recordsPulled ?? 0)
                  )}
                </td>
                <td className="px-4 py-3">{log.recordsCreated ?? 0}</td>
                <td className="px-4 py-3">{log.recordsUpdated ?? 0}</td>
                <td className="max-w-xs truncate px-4 py-3 font-mono text-xs">
                  {log.error || "—"}
                </td>
              </tr>
              {expandedId === log._id && log.error ? (
                <tr className={rowClass(log.status)}>
                  <td colSpan={8} className="px-4 pb-4">
                    <pre className="overflow-x-auto rounded bg-slate-900 p-3 font-mono text-xs text-slate-100">
                      {log.error}
                    </pre>
                  </td>
                </tr>
              ) : null}
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
